import type { GlobalApiErrorCode } from '@data/global-api-errors';

export const isErrorHandled = (
  errorCode: GlobalApiErrorCode | string | null,
  handledErrorCodes: GlobalApiErrorCode[]
): boolean => {
  return handledErrorCodes.includes(errorCode as GlobalApiErrorCode);
};
